import { Toast } from 'primereact/toast';
import { Tooltip } from 'primereact/tooltip';
import React, { useState, useEffect, useRef } from 'react';
import apis from '../../api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import TimePicker from '../TimePicker/TimePicker';
import { Toolbar } from 'primereact/toolbar';
import { excelExport } from '../../services/excelExport.service';
import { excelReport } from '../../services/excelReport.service';
import { FileUpload } from 'primereact/fileupload';
import { saveAs } from 'file-saver';
import { ProgressSpinner } from 'primereact/progressspinner';
import dateFormat from '../../services/DateFormat.service';
import invDateFormat from '../../services/InvertDateFormat.service';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api'
import { Avatar } from 'primereact/avatar';

const Scheduling = () => {
    const [scheduling, setScheduling] = useState([])
    const [contractList, setContractList] = useState([])
    const [costCenterList, setCostCenterList] = useState([])
    const [replacementList, setReplacementList] = useState([])
    const [shiftList, setShiftList] = useState([])
    const [causeList, setCauseList] = useState([])
    const [dayTypeList, setDayTypeList] = useState([])

    const [loadPage, setLoadPage] = useState(false);
    const [loading1, setLoading1] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [loading3, setLoading3] = useState(false)
    const [loading5, setLoading5] = useState(false)
    const [loading6, setLoading6] = useState(false)
    const [isOpenScheduling, setisOpenScheduling] = useState(false)
    const [isOpenSchedulingUpdate, setisOpenSchedulingUpdate] = useState(false)
    const [isOpenSchedulingDelete, setIsOpenSchedulingDelete] = useState(false)
    const [isOpenMultipleDelete, setIsOpenMultipleDelete] = useState(false)

    const headers = { Authorization: localStorage.getItem("token") }
    const client = localStorage.getItem('client')
    const entity = localStorage.getItem('entity')

    const [scheduleId, setScheduleId] = useState("")
    const [contract, setContract] = useState("")
    const [scheduleDate, setScheduleDate] = useState("")
    const [shift, setShift] = useState("")
    const [compensation, setCompensation] = useState("")
    const [costCenter, setCostCenter] = useState("")
    const [replacement, setReplacement] = useState("")
    const [replaceCause, setReplaceCause] = useState("")

    const [loadingExport, setLoadingExport] = useState(false);
    const [exportContent, setExportContent] = useState([])
    const [isOpenCargue, setIsOpenCargue] = useState(false);
    const fileUploadRef = useRef(null);
    const [consultado, setConsultado] = useState(false);
    const [isOpenProcess, setIsOpenProcess] = useState(false);

    const [errorMsg, setErrorMsg] = useState("")
    const [isOpenError, setIsOpenError] = useState(false)

    const toast = useRef(null);

    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [schedulingSelected, setSchedulingSelected] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    useEffect(() => {
        getSchedulingList()
        getScheduling()
    }, [])

    const hideModalScheduling = () => {
        setContract("")
        setShift("")
        setCompensation("")
        setisOpenScheduling(false)
    }

    const hideModalSchedulingUpdate = () => {
        setContract("")
        setShift("")
        setCompensation("")
        setScheduleId("")
        setisOpenSchedulingUpdate(false)
    }

    const hideModalSchedulingDelete = () => {
        setContract("")
        setShift("")
        setCompensation("")
        setScheduleId("")
        setIsOpenSchedulingDelete(false)
    }

    const hideModalMultipleDelete = () => {
        setContract("")
        setShift("")
        setCompensation("")
        setScheduleId("")
        setIsOpenMultipleDelete(false)
    }

    const showModalCargue = () => {
        setIsOpenCargue(true);
    };

    const hideModalCargue = () => {
        setIsOpenCargue(false);
    };

    const showModalProcess = () => {
        setIsOpenProcess(true);
    };

    const hideModalProcess = () => {
        setIsOpenProcess(false);
    };

    //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    //Limpiar e inicializar los filtros
    const clearFilter1 = () => {
        initFilters1();
    }

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm " onClick={clearFilter1} />
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
                </IconField>
            </div>
        )
    }

    //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
    const header1 = renderHeader1();

    //Limpiar filtros de la tabla
    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'JOB': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'CONTRACT_TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'RETIREMENT_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue1('');
    }

    //Nombre de las opciciones para los filtros
    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];
    
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
            { label: 5, value: 5 },
            { label: 10, value: 10 },
            { label: 20, value: 20 }
            ];

            return (
            <React.Fragment>
                <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
                <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
            </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
            <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                {options.first} - {options.last} of {options.totalRecords}
            </span>
            )
        }
    };

    const getSchedulingList = async () => {
        try{
            await apis.schedulingList(entity, client, headers).then(res => { 
                const newContractList = res.data.CONTRACTS.map(con => {
                    const newContract = {
                        ...con,
                        FULL_DATA_CONTRACT: `${con.CONTRACT_ID} ${con.NAME} ${con.JOB_ID}`
                    }
                    return newContract
                })
                const newReplaceList = res.data.REPLACEMENT_ID.map(rep => {
                    const newShift = rep.SHIFTS_ID.split('|')
                    const newReplace = {
                        ...rep,
                        SHIFTS_ID: newShift[0],
                        SHIFTS: newShift[1],
                        FULL_DATA_CONTRACT: `${rep.CONTRACT_ID} ${rep.NAME} ${newShift[0]} ${newShift[1]} ${rep.PROGRAM_DATE}`
                    }
                    return newReplace
                })
                setContractList(newContractList)
                setCostCenterList(res.data.CENTRO_COSTO)
                setReplacementList(newReplaceList)
                setShiftList(res.data.SHIFTS)
                setCauseList(res.data.TRK_REPLACE_CAUSAL)
                setDayTypeList(res.data.TRK_TYPE_DAY)
            })
        }
        catch(error){
            console.log(error)
        }
    }

    const getScheduling = async () => {
        setLoadPage(false)
        try{
            await apis.getScheduling(entity, client, headers).then(res => {
                let data = []
                let exportData = []
                res.data.SHIFTS.forEach(shift => {
                    const shift_ = shift.SHIFTS_ID.split('|')
                    const contract_ = shift.CONTRACT_ID.split('|')
                    const replacement_ = shift.REPLACEMENT_ID.split('|')
                    const cause_ = shift.LOV_CAUSAL.split('|')
                    const status_ = shift.STATUS.split('|')
                    const costCenter_ = shift.COST_CENTER_ID.split('|')
                    const compensation_ = shift.TRK_TYPE_DAY.split('|')
                    let newShift= {
                        ...shift,
                        SHIFTS_ID: shift_[0],
                        SHIFTS: shift_[1],
                        CONTRACT_ID: contract_[0],
                        CONTRACT: contract_[1],
                        LOV_CAUSAL: cause_[0],
                        LOV_CAUSAL_DESC: cause_[1],
                        REPLACEMENT_ID: replacement_[0],
                        REPLACEMENT: replacement_[1],
                        STATUS: status_[0],
                        STATUS_DESC: status_[1],
                        COST_CENTER_ID: costCenter_[0],
                        COST_CENTER: costCenter_[1],
                        TRK_TYPE_DAY: compensation_[0],
                        TRK_TYPE_DAY_DESC: compensation_[1]
                    }
                    let newExport = {
                        ID: shift.PROGRAM_SHIFT_ID,
                        Contrato: contract_[0],
                        Nombre: contract_[1],
                        'Fecha programación': shift.PROGRAM_DATE,
                        'ID configuración turno': shift_[0],
                        'Nombre turno': shift_[1],
                        'Forma compensación domingo': compensation_[1],
                        RDF: shift.RDF,
                        RN: shift.RN,
                        RNF: shift.RNF,
                        'Total RN': shift.TOTAL_RN,
                        HED: shift.HED,
                        HEDF: shift.HEDF,
                        HEN: shift.HEN,
                        HENF: shift.HENF,
                        'Total HE': shift.TOTAL_HE,
                        'Centro de costo contable': costCenter_[1],
                        'Código centro de costo contable': costCenter_[0],
                        'ID programación reemplazo': replacement_[0],
                        'Nombre contrato reemplazo': replacement_[1],
                        'Causal reemplazo': cause_[1],
                        'Estado': status_[1],
                    }
                    data.push(newShift)
                    exportData.push(newExport)
                    
                })
                console.log(data)
                setExportContent(exportData)
                setScheduling(data)
            })
        }
        catch(error){
            console.log(error)
        }
        finally{
            setLoadPage(true)
        }
    }

    const postScheduling = async () => {
        setLoading1(true)
        try{
            const payload = {
                ENTITY: entity,
                CLIENT: client,
                SHIFTS_ID: shift.ID,
                TRK_TYPE_DAY: compensation && compensation.detail_id,
                CONTRACT_ID: contract.CONTRACT_ID,
                PROGRAM_DATE: dateFormat(scheduleDate),
                COST_CENTER_ID: costCenter && costCenter.CENTER_ID,
                REPLACEMENT_ID: replacement && replacement.PROGRAM_SHIFT_ID,
                LOV_CAUSAL: replaceCause && replaceCause.detail_id
            }
            await apis.postScheduling(payload, headers).then(res => {
                getScheduling()
                hideModalScheduling()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Programación creada exitosamente"});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading1(false)
        }
    }

    const putScheduling = async () => {
        setLoading2(true)
        try{
            const payload = {
                ENTITY: entity,
                CLIENT: client,
                PROGRAM_SHIFT_ID: scheduleId,
                SHIFTS_ID: shift.ID,
                TRK_TYPE_DAY: compensation && compensation.detail_id,
                CONTRACT_ID: contract.CONTRACT_ID,
                PROGRAM_DATE: dateFormat(scheduleDate),
                COST_CENTER_ID: costCenter && costCenter.CENTER_ID,
                REPLACEMENT_ID: replacement && replacement.PROGRAM_SHIFT_ID,
                LOV_CAUSAL: replaceCause && replaceCause.detail_id
            }
            await apis.putScheduling(payload, headers).then(res => {
                getScheduling()
                hideModalSchedulingUpdate()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Programación actualizada exitosamente"});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading2(false)
        }
    }

    const deleteScheduling = async (id, type = 'single') => {
        setLoading3(true)
        try{
            await apis.delScheduling(entity, client, id, headers).then(res => {
                getScheduling()
                hideModalSchedulingDelete()
                if(type === 'single'){
                    toast.current.show({ severity: 'info', summary: 'Éxito', detail: "Programación eliminada exitosamente"});
                }
            })
        }
        catch(err){
            if(type === 'single'){
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            }
            else{
                throw err
            }
        }
        finally{
            setLoading3(false)
        }
    }

    const deleteMultipleSchedules = async () => {
        let errorMsg = ""

        const results = await Promise.allSettled(
            schedulingSelected.map((sch) => deleteScheduling(sch.PROGRAM_SHIFT_ID, 'multiple'))
        )

        results.forEach((result) => {
            console.log(result)
            if (result.status === 'rejected') {
                const id = result.reason?.config?.url.split('/')[5]
                errorMsg += "ID " + id + ": " + result.reason?.response?.data?.message
            }
        })

        setLoading3(false)

        if (errorMsg) {
            loadError(errorMsg, "ErroresEliminacion")
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al eliminar la(s) programación(es). Por favor revisar archivo de errores", sticky: true })
        } else {
            hideModalMultipleDelete()
            toast.current.show({ severity: 'info', summary: 'Exitoso', detail: "Programación(es) eliminada(s) exitosamente" })
        }
    }

    const processScheduling = async () => {
        setLoading6(true)
        try{
            const schedules = schedulingSelected.map(sch => {
                return sch.PROGRAM_SHIFT_ID
            })
            const payload = {
                CLIENT: client,
                ENTITY: entity,
                PROGRAM_SHIFT: schedules
            }
            await apis.processScheduling(payload, headers).then(res => {
                hideModalProcess()
                setSchedulingSelected([])
                getScheduling()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading6(false)
        }
    }

    const setScheduleData = (rowData) => {
        const contract_ = contractList.filter(cont => cont.CONTRACT_ID === rowData.CONTRACT_ID)[0]
        const costCenter_ = costCenterList.filter(cos => cos.CENTER_ID === rowData.COST_CENTER_ID)[0]
        const compensation_ = dayTypeList.filter(nov => nov.detail_id === rowData.TRK_TYPE_DAY)[0]
        const shift_ = shiftList.filter(shi => shi.ID === rowData.SHIFTS_ID)[0]
        const replacement_ = replacementList.filter(rep => rep.PROGRAM_SHIFT_ID === rowData.REPLACEMENT_ID)[0]
        const replaceCause_ = causeList.filter(cau => cau.detail_id === rowData.LOV_CAUSAL)[0]
        setScheduleId(rowData.PROGRAM_SHIFT_ID)
        setContract(contract_)
        setCostCenter(costCenter_)
        setShift(shift_)
        setCompensation(compensation_)
        setReplacement(replacement_)
        setReplaceCause(replaceCause_)
        setScheduleDate(invDateFormat(rowData.PROGRAM_DATE))
        setisOpenSchedulingUpdate(true)
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className='flex flex-row gap-1'>
                <Button icon="pi pi-pencil" className="p-button-warning p-button-sm text-xs" onClick={() => setScheduleData(rowData)}/>
                <Button icon="pi pi-trash" className="p-button-danger p-button-sm text-xs" onClick={() => {setScheduleId(rowData.PROGRAM_SHIFT_ID); setIsOpenSchedulingDelete(true)}}/>
            </div>
        )
    }

    const photoBodyTemplate = (rowData) => {
        const photo = rowData.IMAGES ? rowData.IMAGES : process.env.REACT_APP_PROFILE_PIC;
        return (
            <div className='flex flex-row gap-1'>
                <div
                    style={{
                        width: '50px',
                        height: '50px',
                        minWidth: '50px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        flexShrink: 0
                    }}
                >
                    <img
                        src={photo}
                        alt=""
                        loading="eager"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }}
                    />
                </div>
                <div className='flex flex-column ml-2 text-left w-full'>
                    <span className='font-bold'>{rowData.NAME}</span>
                    <span>{rowData.CONTRACT_ID} - {rowData.JOB_ID}</span>
                </div>
            </div>
        );
    }

    const replaceBodyTemplate = (rowData) => {
        return (
            <div className='flex flex-row gap-1'>
                <div className='flex flex-column ml-2 text-left w-full'>
                    <span className='font-bold'>{rowData.CONTRACT_ID} - {rowData.NAME}</span>
                    <span><span className='font-bold'>Programación: </span>{rowData.PROGRAM_SHIFT_ID} - <span className='font-bold'>Fecha: </span>{rowData.PROGRAM_DATE}</span>
                    <span><span className='font-bold'>Turno: </span>{rowData.SHIFTS_ID} - {rowData.SHIFTS}</span>
                </div>
            </div>
        );
    }

    const addSchedulingFooter = (
        <div>
            <Button onClick={() => { setLoading1(false); hideModalScheduling() }}>Cancelar</Button>
            <Button label="Guardar" loading={loading1} onClick={() => postScheduling()} disabled={!contract || !shift || !scheduleDate}/>
        </div>
    );

    const addSchedulingHeader = (
        <div>
            <h3>Agregar programación</h3>
        </div>
    )

    const updateSchedulingFooter = (
        <div>
            <Button onClick={() => { setLoading2(false); hideModalSchedulingUpdate() }}>Cancelar</Button>
            <Button label="Guardar" loading={loading2} onClick={() => putScheduling()} disabled={!contract || !shift || !scheduleDate}/>
        </div>
    );

    const updateSchedulingHeader = (
        <div>
            <h3>Editar programación</h3>
        </div>
    )

    const deleteSchedulingFooter = (
        <div>
            <Button onClick={() => { setLoading3(false); hideModalSchedulingDelete() }}>Cancelar</Button>
            <Button className="p-button-danger" label="Eliminar" loading={loading3} onClick={() => deleteScheduling(scheduleId)} />
        </div>
    );

    const deleteSchedulingHeader = (
        <div>
            <h3>¿Desea eliminar la programación?</h3>
        </div>
    )

    const deleteMultipleFooter = (
        <div>
            <Button onClick={() => { setLoading3(false); hideModalMultipleDelete() }}>Cancelar</Button>
            <Button className="p-button-danger" label="Eliminar" loading={loading3} onClick={() => deleteMultipleSchedules()} />
        </div>
    );

    const deleteMultipleHeader = (
        <div>
            <h3>¿Desea eliminar la(s) programación(es)?</h3>
        </div>
    )

    const processSchedulingFooter = (
        <div>
            <Button onClick={() => { setLoading6(false); hideModalProcess() }}>Cancelar</Button>
            <Button label="Procesar" loading={loading6} onClick={() => processScheduling()} />
        </div>
    );

    const processSchedulingHeader = (
        <div>
            <h3>¿Desea procesar la(s) programación(es) seleccionada(s)?</h3>
        </div>
    )

    const msgContent = (
        <div>
            <a style={{ fontWeight: 'bold', textDecoration: 'underline', color: '#3b82f6' }}>
            {process.env.REACT_APP_DISABLE_MSG}
            </a>
        </div>
    )

    const exportExcel = () => {
        try{
            excelExport(exportContent, 'Programaciones')
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Exportado con éxito" });
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "Error al exportar", sticky: true });
        }
        finally{
            setLoadingExport(false);
        }
    }

    const leftToolbarTemplate = () => {
        return (
            <div className='flex flex-row gap-1'>
                <Button type="button" icon="pi pi-plus" label="Agregar" className="p-button-success p-button-sm" onClick={() => setisOpenScheduling(true)}/>
                <Button label="Cargue" icon="pi pi-upload" className="p-button-success p-button-sm" onClick={showModalCargue} />
                <Button label="Procesar" icon="pi pi-arrow-right-arrow-left" className="p-button-info p-button-sm" onClick={showModalProcess} disabled={schedulingSelected.length < 1}/>
                <Button label="Eliminar" icon="pi pi-trash" className="p-button-danger p-button-sm" onClick={() => setIsOpenMultipleDelete(true)} disabled={schedulingSelected.length < 1}/>
            </div>
        )
    }

    const rightToolbarTemplate = () => {
        return (
          <React.Fragment>
            <Button label="Exportar" icon="pi pi-file-excel" tooltip='Exportar información de la tabla' loading={loadingExport}
                tooltipOptions={{ position: 'top' }} className="p-button-success mr-2 p-button-sm" onClick={() => { setLoadingExport(true); exportExcel() }} />
          </React.Fragment>
        )
    }

    async function downloadSampleFile() {
        let payload = {
            CLIENT: localStorage.getItem('client'),
            ENTITY: localStorage.getItem('entity'),
            OPTION: 2
        }
        let sampleFile = []
        try {
            await apis.uploadScheduling(payload, headers).then(res => {
                sampleFile = res.data
                let nombre = sampleFile["SHEETS"][0]["NAME"]
                excelReport(sampleFile, nombre)
                setLoading5(false)
            });
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            setLoading5(false)
        }
    }

    async function loadError(lines, name = "ErroresCargue") {
        /*Función encargada de generar el archivo txt de errores del cargue*/
        const blob = new Blob([lines], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
        saveAs(blob, name + ".txt");
    }

    async function importData(_importedData) {
        /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
        try {
            await apis.uploadScheduling(_importedData, headers).then(res => {
                setConsultado(false)
                toast.current.clear()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
                hideModalCargue()
                getScheduling()
            })
        }
        catch (err) {
            loadError(err.response.data.message)
            setConsultado(false)
            toast.current.clear()
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al cargar la información. Por favor revisar archivo de errores", sticky: true });
        }
    }

    const showConfirm = () => {
        /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
        toast.current.show({
            severity: 'info', sticky: true, content: (
            <div className="flex flex-column" style={{ flex: '1' }}>
                <div className="text-center">
                    <i >
                        <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-100	)" animationDuration=".5s" />
                    </i>
                    <p>Cargando información...</p>
                </div>
            </div>
            )
        });
    }

    async function importCargue(e) {
        /*Función encargada de formatear los datos del archivo Excel para subirlos*/
        setConsultado(true);
        showConfirm();
        const file = e.files[0];

        import('xlsx').then(xlsx => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });

                // Prepare DataTable
                data.shift();

                let _importedData = {
                    CLIENT: localStorage.getItem('client'),
                    ENTITY: localStorage.getItem('entity'),
                    OPTION: 1,
                    DETAIL: []
                }

                let lines = 1
                data.forEach(row => {
                    let _line = ""
                    row.forEach(element => {
                        _line += element + "|"
                    })
                    _line = _line.slice(0, -1)
                    _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
                    lines++
                })

                importData(_importedData)
            };
            reader.readAsArrayBuffer(file);
        });
    }

    const footerCargue = (
        <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
            <Button style={{ marginLeft: "-6rem" }} label='Cancelar' onClick={() => { setLoading5(false); hideModalCargue() }} />
            <Button type="button" icon="pi pi-file-excel" label="Plantilla" loading={loading5} onClick={() => { setLoading5(true); downloadSampleFile() }} />
            <FileUpload ref={fileUploadRef} disabled={consultado} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importCargue}>
            </FileUpload>
        </div>
    );

    const headerCargue = (
        <div>
            <h3>Cargar programación</h3>
        </div>
    )

    const rowClassName = (rowData) => {
        return { 'error-row': (rowData["STATUS_DESC"] === "ERROR") };
    }

    const errorBodyTemplate = (rowData) => {
        const msg = rowData.ERROR ? rowData.ERROR : "No hay errores"
        setErrorMsg(msg)
        return(
            <Button icon='pi pi-search' severity='secondary' rounded text onClick={() => {setIsOpenError(true)}}/>
        )
    }
    
    const headerError = (
        <div>
            <h3>Error programación</h3>
        </div>
    )

    return(
        <div className="flex flex-wrap align-items-center justify-content-center flex-column align-self-center">
            <Tooltip target=".info" className='indigo-tooltip ml-1' />
            <Toast ref={toast} style={{ backgroundColor: 'white' }} />
            <Dialog header={addSchedulingHeader} footer={addSchedulingFooter} visible={isOpenScheduling}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalScheduling}>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Contrato</label>
                    <Dropdown className='schedule' filter showClear filterBy="FULL_DATA_CONTRACT" optionLabel='NAME' placeholder="Contrato" itemTemplate={photoBodyTemplate} value={contract} options={contractList} onChange={(e) => setContract(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Fecha</label>
                    <Calendar id="navigators" value={scheduleDate} onChange={(e) => setScheduleDate(e.value)} locale="es" dateFormat="dd-mm-yy" showIcon placeholder="Fecha" />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Turno</label>
                    <Dropdown filter showClear filterBy="DESCRIPTION" optionLabel='DESCRIPTION' placeholder="Turno" value={shift} options={shiftList} onChange={(e) => setShift(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Forma de compensación domingo</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Forma de compensación domingo" value={compensation} options={dayTypeList} onChange={(e) => setCompensation(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Centro de costo contable</label>
                    <Dropdown filter showClear filterBy="CENTER_NAME" optionLabel='CENTER_NAME' placeholder="Centro de costo contable" value={costCenter} options={costCenterList} onChange={(e) => setCostCenter(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Programación de reemplazo</label>
                    <Dropdown filter showClear filterBy="FULL_DATA_CONTRACT" optionLabel='NAME' placeholder="Programación de reemplazo" itemTemplate={replaceBodyTemplate} value={replacement} options={replacementList} onChange={(e) => setReplacement(e.value)} />
                </div>
                <div className='flex flex-column gap-1'>
                    <label htmlFor="label">Causal reemplazo</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Causal reemplazo" value={replaceCause} options={causeList} onChange={(e) => setReplaceCause(e.value)} />
                </div>
            </Dialog>
            <Dialog header={updateSchedulingHeader} footer={updateSchedulingFooter} visible={isOpenSchedulingUpdate}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalSchedulingUpdate}>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">ID programación</label>
                    <InputText value={scheduleId} placeholder="ID programación" className="p-inputtext-sm" disabled={true}/>
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Contrato</label>
                    <Dropdown filter showClear filterBy="FULL_DATA_CONTRACT" optionLabel='NAME' placeholder="Contrato" itemTemplate={photoBodyTemplate} value={contract} options={contractList} onChange={(e) => setContract(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Fecha</label>
                    <Calendar id="navigators" value={scheduleDate} onChange={(e) => setScheduleDate(e.value)} locale="es" dateFormat="dd-mm-yy" showIcon placeholder="Fecha" />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Turno</label>
                    <Dropdown filter showClear filterBy="DESCRIPTION" optionLabel='DESCRIPTION' placeholder="Turno" value={shift} options={shiftList} onChange={(e) => setShift(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Forma de compensación domingo</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Forma de compensación domingo" value={compensation} options={dayTypeList} onChange={(e) => setCompensation(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Centro de costo contable</label>
                    <Dropdown filter showClear filterBy="CENTER_NAME" optionLabel='CENTER_NAME' placeholder="Centro de costo contable" value={costCenter} options={costCenterList} onChange={(e) => setCostCenter(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Programación de reemplazo</label>
                    <Dropdown filter showClear filterBy="FULL_DATA_CONTRACT" optionLabel='NAME' placeholder="Programación de reemplazo" itemTemplate={replaceBodyTemplate} value={replacement} options={replacementList} onChange={(e) => setReplacement(e.value)} />
                </div>
                <div className='flex flex-column gap-1'>
                    <label htmlFor="label">Causal reemplazo</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Causal reemplazo" value={replaceCause} options={causeList} onChange={(e) => setReplaceCause(e.value)} />
                </div>
            </Dialog>
            <Dialog header={deleteSchedulingHeader} footer={deleteSchedulingFooter} visible={isOpenSchedulingDelete}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalSchedulingDelete}>
            </Dialog>
            <Dialog header={deleteMultipleHeader} footer={deleteMultipleFooter} visible={isOpenMultipleDelete}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalMultipleDelete}>
            </Dialog>
            <Dialog header={processSchedulingHeader} footer={processSchedulingFooter} visible={isOpenProcess}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalProcess}>
            </Dialog>
            <Dialog header={headerCargue} footer={footerCargue} visible={isOpenCargue}
                position="top" style={{ width: "28rem" }} draggable={false} resizable={false} modal onHide={hideModalCargue}>
                <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
                <br />
                <span>2. Diligencie la hoja Upload_scheduling_contracts, teniendo en cuenta las instrucciones de la hoja Instructivo.</span>
                <br />
                <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
            </Dialog>
            <Dialog header={headerError} visible={isOpenError}
                position="top" style={{ width: "26rem"}} contentStyle={{ background: '#f7ee9e', display: "flex", justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }} headerStyle={{ background: '#f7ee9e'}} draggable={false} resizable={false} modal onHide={() => setIsOpenError(false)}>
                    <Avatar icon='pi pi-exclamation-triangle' style={{background: '#f7ee9e'}} size='xlarge'/>
                    <span>{errorMsg}</span>
            </Dialog>
            <div className="flex flex-column align-items-center justify-content-center font-bold text-4xl mt-5">
                <span className="text-900">Programación</span>
            </div>
            {localStorage.getItem('tracking') === 'N'?
                <div className='flex justify-content-center'>
                    <Card style={{ width: "60%" }}>
                        <Message severity="info"
                        style={{
                            width: "100%",
                            fontSize: "18px",
                            border: 'solid #696cff',
                            borderWidth: '2px',
                            color: '#696cff'
                        }}
                        content={msgContent}
                        />
                    </Card>
                </div>:
                <div className="card mt-4 w-9 datatable-style-demo">
                    <SkeletonTable load={loadPage}>
                        <Toolbar start={leftToolbarTemplate} end={rightToolbarTemplate} />
                        <DataTable className="text-xs" value={scheduling} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                            selection={schedulingSelected} onSelectionChange={(e) => setSchedulingSelected(e.value)} dataKey="PROGRAM_SHIFT_ID" selectionMode="multiple"
                            size="small" filters={filters1} filterDisplay="menu" header={header1} rowClassName={rowClassName}
                            globalFilterFields={['PROGRAM_SHIFT_ID', 'CONTRACT_ID', 'CONTRACT', 'PROGRAM_DATE', 'SHIFTS_ID', 'SHIFTS', 'COST_CENTER', 'COST_CENTER_ID', 'STATUS_DESC', 'LOV_STATUS_DESC', 'TRK_TYPE_DAY_DESC']}
                        >
                            <Column selectionMode="multiple" headerStyle={{ width: '3em' }}></Column>
                            <Column field="ERROR" header="Error" body={errorBodyTemplate}></Column>
                            <Column field="PROGRAM_SHIFT_ID" header="ID" filter filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por ID" sortable></Column>
                            <Column field="CONTRACT_ID" header="Contrato" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Contrato" sortable></Column>
                            <Column field="CONTRACT" header="Nombre"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
                            <Column field="PROGRAM_DATE" header="Fecha programación"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha programación" sortable></Column>
                            <Column field="SHIFTS_ID" header="ID configuración turno"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por ID configuración turno" sortable></Column>
                            <Column field="SHIFTS" header="Nombre turno" filter filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por Nombre turno" sortable></Column>
                            <Column field="TRK_TYPE_DAY_DESC" header="Forma compensación domingo" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Forma compensación domingo" sortable></Column>
                            <Column field="RDF" header="RDF"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por RDF" sortable></Column>
                            <Column field="RN" header="RN"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por RN" sortable></Column>
                            <Column field="RNF" header="RNF"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por RNF" sortable></Column>
                            <Column field="TOTAL_RN" header="Total RN" filter filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por Total RN" sortable></Column>
                            <Column field="HED" header="HED" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por HED" sortable></Column>
                            <Column field="HEDF" header="HEDF"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por HEDF" sortable></Column>
                            <Column field="HEN" header="HEN"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por HEN" sortable></Column>
                            <Column field="HENF" header="HENF"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por HENF" sortable></Column>
                            <Column field="TOTAL_HE" header="Total HE" filter filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por Total HE" sortable></Column>
                            <Column field="COST_CENTER" header="Centro de costo contable" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Centro de costo contable" sortable></Column>
                            <Column field="COST_CENTER_ID" header="Código centro de costo contable"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Código centro de costo contable" sortable></Column>
                            <Column field="REPLACEMENT_ID" header="ID programación reemplazo"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por ID programación reemplazo" sortable></Column>
                            <Column field="REPLACEMENT" header="Nombre contrato reemplazo"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre contrato reemplazo" sortable></Column>
                            <Column field="LOV_CAUSAL_DESC" header="Causal reemplazo"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Causal reemplazo" sortable></Column>
                            <Column field="STATUS_DESC" header="Estado"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
                            <Column header="Acciones" headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
                        </DataTable>
                    </SkeletonTable>
                </div>
                }
        </div>
    )
}

export default Scheduling
